import { useEffect, useRef } from "react";
import Router from "next/router";

const useIdleLogout = (timeoutMinutes, onLogout) => {
  const timerRef = useRef(null);

  const resetTimer = () => {
    // Clear the existing timer
    if (timerRef.current) clearTimeout(timerRef.current);

    // Set a new timer
    timerRef.current = setTimeout(() => {
      onLogout();
    }, timeoutMinutes * 60 * 1000); // Convert minutes to milliseconds
  };

  useEffect(() => {
    // Activity events to listen for
    const events = ["mousemove", "keydown", "scroll", "click"];

    // Reset timer on activity
    const handleActivity = () => resetTimer();

    // Attach event listeners
    events.forEach((event) =>
      window.addEventListener(event, handleActivity)
    );

    // Set initial timer
    resetTimer();

    // Cleanup on unmount
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
    };
  }, [timeoutMinutes]);

  return null; // Hook doesn't render anything
};

export default useIdleLogout;
